import type { FilterGroup } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { extractCategoryFilters, extractCategoryFilterValues } from '@app/src/utils/filterUtils'

const CATEGORY_OPTIONS_NAME = 'categoryOptions.id'
const COUNTRY_FILTER_NAME = 'country.id'
const ACTOR_TYPE_ID_FILTER_NAME = 'mappingNodes.actorType.id'
const SOURCE_FILTER_NAME = 'assessments.isScreened'

export interface ExtractedFilterData {
  standardCategoriesFilter: FilterGroup[]
  categoryOptionsFilterValue: string[]
  countryFilterValue: string[]
  actorTypeIdFilterValue: string[]
  allCategoriesValues: string[]
  assessmentCategoryFilters: FilterGroup[]
  assessmentCategoryValues: string[]
  sourceFilterValue: string
}

function getFilterValue(filters: FilterGroup[] | undefined, name: string): string[] {
  return (filters?.find(cf => cf.name === name)?.filters?.[0]?.value as string[]) ?? []
}

function convertSourceFilterValue(categoryFilters: FilterGroup[] | undefined): string {
  const rawValue = categoryFilters?.find(cf => cf.name === SOURCE_FILTER_NAME)?.filters?.[0]?.value
  const actualValue = Array.isArray(rawValue) ? rawValue[0] : rawValue

  if (actualValue === true || actualValue === 'true') {
    return 'AI screened'
  } else if (actualValue === false || actualValue === 'false') {
    return 'Self-reported'
  }
  return ''
}

export function extractFilterData(categoryFilters: FilterGroup[] | undefined): ExtractedFilterData {
  const assessmentCategoryFilters = extractCategoryFilters(categoryFilters) ?? []

  return {
    standardCategoriesFilter: categoryFilters?.filter(cf => cf.name !== CATEGORY_OPTIONS_NAME) ?? [],
    categoryOptionsFilterValue: getFilterValue(categoryFilters, CATEGORY_OPTIONS_NAME),
    countryFilterValue: getFilterValue(categoryFilters, COUNTRY_FILTER_NAME),
    actorTypeIdFilterValue: getFilterValue(categoryFilters, ACTOR_TYPE_ID_FILTER_NAME),
    allCategoriesValues: extractCategoryFilterValues(categoryFilters) ?? [],
    assessmentCategoryFilters,
    assessmentCategoryValues: extractCategoryFilterValues(assessmentCategoryFilters) ?? [],
    sourceFilterValue: convertSourceFilterValue(categoryFilters),
  }
}
